<template> 
   <div class="base64-upload" id="base64-upload"> 
     <!-- 文件预览区域 --> 
     <div v-if="previewUrl.length" class="preview-container"> 
       <div v-for="(item, index) in previewUrl" :key="index" class="preview-content"> 
         <!-- 图片预览 --> 
         <img 
           :src="showImages(item,`credentialImg${index}`)" 
           :id="`credentialImg${index}`" 
           class="preview-image" 
           alt="" 
           :style="{ 'max-width': imageWidth, 'max-height': imageHeight }" 
         /> 
         <!-- 操作按钮 --> 
         <div class="preview-actions" v-if="!disabled"> 
           <el-icon @click="handleReplace(item, index)" :disabled="disabled"> 
             <Upload /> 
           </el-icon> 
           <el-icon @click="handleClear(index)" :disabled="disabled"> 
             <Delete /> 
           </el-icon> 
         </div> 
       </div> 
     </div> 
      <el-upload 
       ref="uploadRef" 
       v-bind="$attrs" 
       :class="{'hide-upload': previewUrl.length >= limit }" 
       :action="'/gw-api'+action" 
       :headers="headers" 
       :show-file-list="false" 
       :on-success="handleSuccess" 
       :on-error="handleError" 
       :on-remove="handleRemove" 
       :disabled="disabled" 
       :before-upload="beforeUpload" 
       :on-exceed="handleExceed" 
       :limit="limit" 
       :auto-upload="false"
      :on-change="handleChange"
       multiple 
     > 
       <template #trigger> 
         <slot name="trigger"> 
            <el-icon class="avatar-uploader-icon"><Plus /></el-icon> 
         </slot> 
       </template> 
     </el-upload> 
   </div> 
 </template> 
 
 
 <script setup> 
 import { ref, computed, defineProps, defineEmits, onMounted, onUnmounted, watch } from "vue"; 
 import request from "@/utils/request.ts"; 
 import { getToken, getTenant, getImageUrl } from "@/utils/auth"; 
 import { ElMessage } from "element-plus"; 
 import { Upload, Delete } from "@element-plus/icons-vue"; 
 
 
 const props = defineProps({ 
   // v-model 绑定值 (Base64字符串数组) 
   modelValue: { 
     type: Array, 
     default: "" 
   }, 
   // 是否禁用 
   disabled: { 
     type: Boolean, 
     default: false 
   }, 
   // 接受的文件类型 
   accept: { 
     type: String, 
     default: "" 
   }, 
   // 图片最大宽度 
   imageWidth: { 
     type: String, 
     default: "80px" 
   }, 
   // 图片最大高度 
   imageHeight: { 
     type: String, 
     default: "80px" 
   }, 
   // 文件大小限制 (MB) 
   maxSize: { 
     type: Number, 
     default: 10 
   }, 
   // 上传地址 (保留el-upload的原生功能) 
   action: { 
     type: String, 
     default: "" 
   }, 
   // 上传文件数量限制 
   limit: { 
     type: Number, 
     default: 5 
   }, 
   fullImgUrl: { 
     type: Boolean, 
     default: true 
   }, 
   isNotIncome: { 
     type: Boolean, 
     default: false 
   } 
 }); 
 
 
 const emit = defineEmits(["update:modelValue", "change", "error"]); 
 
 
 const uploadRef = ref(null); 
 
 // 已上传图片的哈希值集合，用于防止重复上传
 const uploadedImageHashes = ref(new Set());
 
 // 保存文件哈希值与URL的映射关系
 const fileHashToUrlMap = ref(new Map());
 
 
 const headers = computed(() => ({ 
   Authorization: getToken(), 
   Tenant: getTenant(), 
   "X-Requested-With": "XMLHttpRequest" 
 })); 
 
 
 const previewUrl = computed(() => { 
   return props.modelValue ? props.modelValue.split(";").filter(item => item) : []; 
 }); 
 
 
 const showImages = (urlAddr,id)=>{ 
   if(!props.isNotIncome) { 
     return getImageUrl(urlAddr) 
   }else{ 
     getUrl(urlAddr,id) 
     return '' 
   } 
 } 
 
 
 // 查看图片路径 
 const getUrl = async (urlAddr,id) => { 
   const response = await fetch( 
     `/gw-api/customer/keyAccountIncomeLog/viewKeyAccountCredential/${urlAddr}`, 
     { 
       headers: { 
         Tenant: getTenant(), 
         "Content-Type": "application/json", 
         Authorization: getToken() 
       } 
     } 
   ); 
   if (!response.ok) { 
     throw new Error("Network response was not ok"); 
   } 
   const data = await response.blob(); 
   const url = URL.createObjectURL(data); 
   const previewQrCodeNode = document.getElementById(id) 
   if(previewQrCodeNode) { 
     previewQrCodeNode.src = url 
   } 
 }; 
 
// 计算文件的MD5哈希值
const calculateFileHash = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const arrayBuffer = e.target.result;
      const bytes = new Uint8Array(arrayBuffer);
      let hash = 0;
      for (let i = 0; i < bytes.length; i++) {
        hash = ((hash << 5) - hash) + bytes[i];
        hash |= 0; // Convert to 32-bit integer
      }
      resolve(hash.toString(16));
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};
 
// 阻止自动上传
const beforeUpload = async (file) => {
  const isLtMaxSize = file.size / 1024 / 1024 < props.maxSize;
  if (!isLtMaxSize) {
    ElMessage.error(`文件大小不能超过${props.maxSize}MB`);
    return false;
  }

  // 检查是否为重复图片
  try {
    const fileHash = await calculateFileHash(file);
    if (uploadedImageHashes.value.has(fileHash)) {
      ElMessage.warning('该截图已上传，请不要重复上传！');
      return false;
    }
    // 将当前文件的哈希值加入集合（临时）
    uploadedImageHashes.value.add(fileHash);
     uploadFile(file);
    return false;
  } catch (error) {
    console.error('计算文件哈希值失败:', error);
    // 计算失败时允许上传
     uploadFile(file);
    return false;
  }
}; 
 
 
 // 文件超出限制 
 const handleExceed = () => { 
   ElMessage.error(`最多只能上传${props.limit}个文件`); 
 }; 
 
 // 处理文件选择事件
const handleChange = (file, fileList) => {
  if (file.status === 'ready') {
    beforeUpload(file.raw);
  }
};
 
 // 清除文件 
 const handleClear = (index) => { 
   // 获取要删除的文件URL
   const fileUrl = previewUrl.value[index];
   
   // 从哈希集合中移除对应的哈希值
   for (const [hash, url] of fileHashToUrlMap.value.entries()) {
     if (url === fileUrl) {
       uploadedImageHashes.value.delete(hash);
       fileHashToUrlMap.value.delete(hash);
       break;
     }
   }
   
   // 更新预览列表
   const newModelValue = previewUrl.value.filter((_, i) => i !== index);
   emit("update:modelValue", newModelValue.join(';'));
   emit("change", newModelValue);
 }; 
 
 
 // 替换文件 
 const handleReplace = (item, index) => { 
   handleClear(index); 
   uploadRef.value.$el.querySelector("input").click(); 
 }; 
 
 
 // 移除文件 
 const handleRemove = (file, fileList) => { 
   // 从哈希集合中移除对应的哈希值
   for (const [hash, url] of fileHashToUrlMap.value.entries()) {
     if (url === file) {
       uploadedImageHashes.value.delete(hash);
       fileHashToUrlMap.value.delete(hash);
       break;
     }
   }
   
   // 更新预览列表
   const newModelValue = previewUrl.value.filter(item => item !== file);
   emit("update:modelValue", newModelValue.join(';'));
   emit("change", newModelValue); 
 }; 
 
 
 const handleSuccess = async (response, file) => { 
   if (response.code === 200) { 
     const fileUrl = response.data; 
     const newModelValue = !props.modelValue 
       ? fileUrl 
       : props.modelValue + `;${fileUrl}`; 
     
     // 获取文件哈希值并存储映射关系
     try {
       const fileHash = await calculateFileHash(file);
       fileHashToUrlMap.value.set(fileHash, fileUrl);
     } catch (error) {
       console.error('计算文件哈希值失败:', error);
     }
     
     emit("update:modelValue", newModelValue); 
     emit("change", newModelValue); 
     // 成功之后清空剪切板内容
     navigator.clipboard.writeText('');
     ElMessage.success("文件导入成功"); 
   } else { 
     // 上传失败时，从哈希集合中移除该文件的哈希值
     try {
       const fileHash = await calculateFileHash(file);
       uploadedImageHashes.value.delete(fileHash);
     } catch (error) {
       console.error('计算文件哈希值失败:', error);
     }
     ElMessage.error("文件导入失败"); 
   } 
 }; 
 
 
 const handleError = async (err, file) => { 
   console.error("上传失败:", err); 
   // 上传失败时，从哈希集合中移除该文件的哈希值
   if (file) {
     try {
       const fileHash = await calculateFileHash(file);
       uploadedImageHashes.value.delete(fileHash);
     } catch (error) {
       console.error('计算文件哈希值失败:', error);
     }
   }
   ElMessage.error("上传失败"); 
 }; 
 
 
 // 处理粘贴事件，重复粘贴时不触发上传 
 const handlePaste = async (event) => { 
   if (props.disabled) return; 
   
   // 检查页面是否包含base64-upload组件
   const isInComponent = document.querySelector('#base64-upload');
   if (!isInComponent) {
     return; // 不在当前组件范围内，忽略粘贴事件
   } 

   // 检查是否超过上传限制 
   if (previewUrl.value.length >= props.limit) { 
     ElMessage.error(`最多只能上传${props.limit}个文件`); 
     return; 
   } 
   
   // 获取剪贴板中的图片 
   const items = event.clipboardData?.items; 
   if (!items) return; 
   for (const item of items) { 
     // 检查是否为图片类型 
     if (item.type.indexOf('image') !== -1) { 
       const file = item.getAsFile(); 
       if (file) { 
         // 检查文件大小 
         if (file.size / 1024 / 1024 > props.maxSize) { 
           ElMessage.error(`文件大小不能超过${props.maxSize}MB`); 
           continue; 
         } 
         
         // 检查文件类型 - 改进版本，支持更多图片类型 
         if (props.accept) { 
           // 解析accept属性，支持多种格式 
           const acceptTypes = props.accept.toLowerCase().split(',').map(type => type.trim()); 
           const fileType = file.type.toLowerCase();
           const fileExt = file.name.toLowerCase().split('.').pop();
           
           // 检查是否为图片类型 
           let isAcceptable = false; 
           
           // 遍历接受的类型 
           for (const acceptType of acceptTypes) { 
             if (acceptType === 'image/*') { 
               // 支持所有图片类型 
               isAcceptable = fileType.startsWith('image/'); 
             } else if (acceptType.startsWith('.')) { 
               // 支持扩展名格式如".png" 
               const ext = acceptType.substring(1); 
               isAcceptable = fileExt === ext || fileType === `image/${ext}`; 
             } else if (acceptType.includes('/')) { 
               // 支持MIME类型格式如"image/png" 
               isAcceptable = fileType === acceptType; 
             } 
             
             if (isAcceptable) break; 
           } 
           
           if (!isAcceptable) { 
             ElMessage.error('文件类型不支持'); 
             continue; 
           } 
         } 
         
         // 检查是否为重复图片
         try {
           const fileHash = await calculateFileHash(file);
           if (uploadedImageHashes.value.has(fileHash)) {
             ElMessage.warning('该截图已上传，请不要重复上传！');
             continue;
           }
           // 将当前文件的哈希值加入集合（临时）
           uploadedImageHashes.value.add(fileHash);
         } catch (error) {
           console.error('计算文件哈希值失败:', error);
           // 计算失败时允许上传
         }
         
         // 手动上传文件 
         uploadFile(file); 
       } 
     } 
   }  
 }; 
 
 
 // 手动上传文件 
 const uploadFile = (file) => { 
   if (!props.action) { 
     ElMessage.error('上传地址未配置');
     // 上传失败时，从哈希集合中移除该文件的哈希值
     calculateFileHash(file).then((fileHash) => {
       uploadedImageHashes.value.delete(fileHash);
     }).catch(error => {
       console.error('计算文件哈希值失败:', error);
     });
     return; 
   } 
   
   const formData = new FormData(); 
   formData.append('file', file); 
   
   // 调用上传接口 
   request.post(props.action, formData, { 
     headers: { 
       ...headers.value, 
       'Content-Type': 'multipart/form-data' 
     }, 
     onUploadProgress: (progressEvent) => { 
       // 可以添加上传进度显示逻辑 
     } 
   }).then(response => { 
     handleSuccess(response, file); 
   }).catch(error => { 
     handleError(error, file); 
   }); 
 }; 
 
 
 // 监听modelValue变化，清理无效的哈希值映射
 watch(() => props.modelValue, (newValue) => {
   if (!newValue) {
     // 如果modelValue被清空，也清空哈希集合和映射
     uploadedImageHashes.value.clear();
     fileHashToUrlMap.value.clear();
     return;
   }
   
   const currentUrls = newValue.split(';').filter(item => item);
   
   // 清理不再存在的URL的哈希值映射
   for (const [hash, url] of fileHashToUrlMap.value.entries()) {
     if (!currentUrls.includes(url)) {
       fileHashToUrlMap.value.delete(hash);
       uploadedImageHashes.value.delete(hash);
     }
   }
 });
 
 // 组件挂载时添加粘贴事件监听 
 onMounted(() => { 
   document.addEventListener('paste', handlePaste, { capture: true }); 
 }); 
 
 
 // 组件卸载时移除粘贴事件监听 
 onUnmounted(() => { 
   document.removeEventListener('paste', handlePaste, { capture: true }); 
   // 清空哈希集合和映射
   uploadedImageHashes.value.clear();
   fileHashToUrlMap.value.clear();
   // 清空剪切板内容
   navigator.clipboard.writeText('');
 }); 
 </script> 
 
<style scoped>
.base64-upload {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.preview-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}
.preview-container:hover .preview-actions {
  display: flex;
}

.preview-content {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-image {
  width: v-bind(imageWidth);
  height: v-bind(imageHeight);
  display: block;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.file-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.file-name {
  margin-top: 5px;
  font-size: 14px;
  word-break: break-all;
  text-align: center;
}

.file-size {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.preview-actions {
  display: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.el-icon {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.el-icon:first-child {
  margin-right: 8px;
}
.el-icon.avatar-uploader-icon {
  border: 1px dashed #ddd;
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  text-align: center;
}
</style>
